import React from 'react';
import { Phone, MessageCircle, MapPin, Clock, Send } from 'lucide-react';
import { businessInfo } from '../../data/mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0a0a0a] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 lg:px-[7.6923%] py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="/logo192.png" 
                alt="NOZEN FLASHER Logo" 
                className="w-12 h-12 object-contain"
              />
              <div>
                <h3 className="text-white font-semibold text-xl">{businessInfo.name}</h3>
                <p className="text-[#00FFD1] text-sm">{businessInfo.tagline}</p>
              </div>
            </div>
            <p className="text-white/60 text-base leading-relaxed mb-6 max-w-md">
              Layanan jasa root dan flash Android profesional dengan teknisi berpengalaman. 
              Melayani area Bekasi, Tambun, Cibitung, dan Cikarang.
            </p>
            <div className="flex items-center gap-2 text-white/40 text-sm">
              <span>Wilayah Layanan:</span>
              <span className="text-[#00FFD1]">
                {businessInfo.serviceAreas.join(' • ')}
              </span>
            </div>
          </div>

          {/* Contact Section */}
          <div>
            <h4 className="text-white font-semibold text-lg mb-6">Kontak</h4>
            <ul className="space-y-4">
              <li>
                <a
                  href={`tel:${businessInfo.phone}`}
                  className="flex items-center gap-3 text-white/70 hover:text-[#00FFD1] transition-colors"
                >
                  <Phone className="w-5 h-5" />
                  <span>{businessInfo.phone}</span>
                </a>
              </li>
              <li>
                <a
                  href={businessInfo.whatsappLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-white/70 hover:text-[#00FFD1] transition-colors"
                >
                  <MessageCircle className="w-5 h-5" />
                  <span>WhatsApp</span>
                </a>
              </li>
              <li>
                <a
                  href={businessInfo.telegramLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-white/70 hover:text-[#00FFD1] transition-colors"
                >
                  <Send className="w-5 h-5" />
                  <span>Telegram {businessInfo.telegram}</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-white/70">
                <Clock className="w-5 h-5 mt-0.5" />
                <span>{businessInfo.operationalHours}</span>
              </li>
            </ul>
          </div>

          {/* Address Section */}
          <div>
            <h4 className="text-white font-semibold text-lg mb-6">Alamat</h4>
            <div className="flex items-start gap-3 text-white/70">
              <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0" />
              <div>
                <p>{businessInfo.address.street}</p>
                <p>{businessInfo.address.district}</p>
                <p>{businessInfo.address.city}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* SEO Keywords Section */}
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-5 lg:px-[7.6923%] py-8">
          <p className="text-white/20 text-xs text-center leading-relaxed mb-3">
            Layanan Profesional: Module Magisk • LSPosed • Mod Gacor • Modul Gacor • 
            Gojek Indonesia • GoFood • Grab Indonesia • GrabFood • InDriver • Maxim Indonesia • 
            Root Android Ojol • Fake GPS • Hide Root • Magisk Hide • Zygisk • 
            Jasa Root Bekasi • Flash Android Tambun • Servis HP Cikarang • Custom ROM Cibitung
          </p>
          <p className="text-white/15 text-xs text-center leading-relaxed mb-3">
            Fake GPS Ojol • Absen • Absensi Online • Module Play Integrity • Play Integrity Fix • 
            Build ROM • SafetyNet • Banking Apps Root • DenyList • Shamiko • Tuyul • Titik Gacor •
            Universal SafetyNet Fix • Root Detection Bypass • TWRP Recovery • Bypass FRP • Unlock Pattern
          </p>
          <p className="text-white/10 text-xs text-center leading-relaxed">
            Support Merek: Samsung • Xiaomi • Realme • Redmi • Vivo • Sony • Infinix • iPhone • 
            OPPO • POCO • ASUS ROG • Honor • Huawei • OnePlus • Motorola • Lenovo • Nokia • Tecno • Itel •
            Jasa Flash Samsung Bekasi • Root Xiaomi Tambun • Flash Realme Cikarang • Root Redmi Cibitung • 
            Servis Vivo Bekasi • Flash Infinix Tambun • Unlock iPhone Bekasi
          </p>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 lg:px-[7.6923%] py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white/40 text-sm">
              © {currentYear} {businessInfo.name}. All rights reserved.
            </p>
            <p className="text-white/40 text-sm">
              Jasa Root & Flash Android Profesional
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
